import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { useStores } from "../../../../../store/root.js";
import { defaultTranslationFlexNamePath } from "../../../../../util/template/form.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { getInputPropsDefaultLang, hasTranslationFlagsChanged } from "../../../../../util/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
import { TranslationInputFormFields } from "./translation/language-input/language-input-form-fields.js";
const FormFieldTemplateSubHeadline = observer(()=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore, rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const { isTranslationMode } = translationSettings;
    // Triggers form item re-render on translation mode toggle
    const lastKnownTranslationMode = isTranslationMode;
    const form = Form.useFormInstance();
    const headlineRules = useMemo(()=>[
            {
                max: 255,
                message: t("Please limit the subheadline to 255 characters.")
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.SubHeadline,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.SubHeadline, t),
            extra: t("Will be displayed in overviews."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || hasTranslationFlagsChanged(prev, next, TemplateMetaDataField.SubHeadline) || lastKnownTranslationMode !== isTranslationMode,
            children: ()=>{
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            rules: headlineRules,
                            hasFeedback: true,
                            name: TemplateMetaDataField.SubHeadline,
                            noStyle: true,
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: t("e.g. Cookie Consent Banner Plugin for WordPress"),
                                maxLength: 255,
                                ...getInputPropsDefaultLang(translationSettings, TemplateMetaDataField.SubHeadline, form),
                                disabled: !rcbAuthenticationStore.hasRole(EUserRole.Creator)
                            })
                        }),
                        /*#__PURE__*/ _jsx(TranslationInputFormFields, {
                            flexPathConfig: {
                                absolute: {
                                    namePath: defaultTranslationFlexNamePath(TemplateMetaDataField.SubHeadline)
                                }
                            },
                            inputProps: {
                                maxLength: 255
                            }
                        })
                    ]
                });
            }
        })
    });
});
export { FormFieldTemplateSubHeadline };
